import { useEffect } from 'react';
import { captureException } from '@/modules/capture-exception';
import { track } from '@/shared/utils/track';
import UiError from '@/UiError';

// The router's match boundaries catch route-tree render crashes before the
// root Sentry.ErrorBoundary can; without a defaultErrorComponent the router
// renders its own raw-stack page and the crash reaches neither Sentry nor
// analytics.
export default function RouteError({ error }: { error: unknown }) {
  useEffect(() => {
    captureException(error);
    track('error_page_shown');
  }, [error]);
  return <UiError />;
}
